import EmailUpdate from '../../components/organisms/EmailUpdate'

const EmailUpdateScreen = props => <EmailUpdate {...props} />

export default EmailUpdateScreen
